"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsyncHook = exports.SyncHook = exports.ReadableEvent = exports.eventWrap = void 0;
var events_1 = require("events");
var rx_1 = require("./rx");
function eventWrap(node) {
    var list = [];
    var addEventListener = function (event, callback) {
        node.addEventListener(event, callback);
        var unListen = function () { return node.removeEventListener(event, callback); };
        list.push(unListen);
        return unListen;
    };
    var r = {
        node: node,
        addEventListener: addEventListener,
        dispose: function () {
            list.forEach(function (fn) { return fn(); });
            list = [];
        },
    };
    return r;
}
exports.eventWrap = eventWrap;
var ReadableEvent = /** @class */ (function () {
    function ReadableEvent() {
        var _this = this;
        this.event = new events_1.EventEmitter();
        this.latest = {};
        this.on = function (eventName, fn, immediate) {
            if (immediate === void 0) { immediate = false; }
            if (immediate && _this.getValue(eventName)) {
                fn(_this.getValue(eventName));
            }
            _this.event.on(eventName, fn);
            return function () { return _this.event.removeListener(eventName, fn); };
        };
        this.once = function (eventName, fn, immediate) {
            if (immediate === void 0) { immediate = false; }
            if (immediate && _this.getValue(eventName)) {
                fn(_this.getValue(eventName));
                return function () { return void 0; };
            }
            var wrapFn = function (data) {
                _this.event.removeListener(eventName, fn);
                fn(data);
            };
            _this.event.on(eventName, wrapFn);
            return function () { return _this.event.removeListener(eventName, wrapFn); };
        };
        this.emit = function (eventName, data) {
            _this.latest[eventName] = data;
            var result = _this.event.emit(eventName, data);
            return result;
        };
        this.removeListener = function (eventName, fn) {
            _this.event.removeListener(eventName, fn);
        };
    }
    ReadableEvent.prototype.getValue = function (name) {
        return this.latest[name];
    };
    ReadableEvent.prototype.clearValue = function (k) {
        this.latest[k] = undefined;
    };
    ReadableEvent.prototype.rx = function (eventName) {
        return rx_1.BehaviorSubject.fromEvent(this, eventName);
    };
    return ReadableEvent;
}());
exports.ReadableEvent = ReadableEvent;
// simplify version of https://github.com/webpack/tapable
var SyncHook = /** @class */ (function () {
    function SyncHook() {
        var _this = this;
        this.hooks = {};
        /** 业务层使用 */
        this.tap = function (name, callback) {
            _this.hooks[name] = callback;
        };
        /** 框架内使用 */
        this.call = function (params, config) {
            var e_1, _a;
            if (config === void 0) { config = {}; }
            var list = Object.keys(_this.hooks);
            var prev = params;
            try {
                for (var list_1 = __values(list), list_1_1 = list_1.next(); !list_1_1.done; list_1_1 = list_1.next()) {
                    var name_1 = list_1_1.value;
                    try {
                        prev = _this.hooks[name_1].call(null, prev, config);
                    }
                    catch (e) {
                        console.error("tap invoke ".concat(name_1, " failed"), e === null || e === void 0 ? void 0 : e.message);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (list_1_1 && !list_1_1.done && (_a = list_1.return)) _a.call(list_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return prev;
        };
    }
    return SyncHook;
}());
exports.SyncHook = SyncHook;
var AsyncHook = /** @class */ (function () {
    function AsyncHook() {
        var _this = this;
        this.hooks = {};
        this.tap = function (name, callback) {
            _this.hooks[name] = callback;
        };
        this.call = function (params) {
            var list = Object.keys(_this.hooks).map(function (name) { return _this.hooks[name](params); });
            return Promise.all(list).then;
        };
    }
    return AsyncHook;
}());
exports.AsyncHook = AsyncHook;
